import ActivityGoodsList from "@/components/course/ActivityGoodsList";
export default {
  name: "CourseGoods",
  components: {
    ActivityGoodsList: ActivityGoodsList
  },
  data: function data() {
    return {};
  },
  methods: {
    selectActivity: function selectActivity(item) {
      this.$router.push({
        path: "/activity/detail?actId=".concat(item.id)
      });
    }
  }
};